export default "__VITE_ASSET__28cb75d7__"